<div class="series-audit-history form-paginator">
  <div class="row auto space-between">
    <utils-bar [search]="true"
               (searchValueSubmitted)="applyFilter($event)"
               (searchCleared)="applyFilter($event)">
    </utils-bar>
    <mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 200]" [pageSize]="pageSize" style="align-items: center;"
                   showFirstLastButtons></mat-paginator>
  </div>

  @if (loading) {
    <div class="stage">
      <div class="dot-flashing"></div>
    </div>
  }

  @if (!loading && dataSource?.data?.length) {
    <div class="table-container">
      <table [dataSource]="dataSource"
             class="table striped-table series-audit-history-table" mat-table matSort style="width:100%;"
             matSortActive="timestamp" matSortDirection="desc">
        @for (column of columns; track column) {
          <ng-container [matColumnDef]="column">
            <th *matHeaderCellDef [mat-sort-header]="column" mat-header-cell>
              <ng-container>{{column | upperfirst | removeUnderscore}}</ng-container>
            </th>
            @if (column !== 'comments') {
              <td *matCellDef="let item;" mat-cell>
                @if (column === 'timestamp' || column === 'changed_on') {
                  <span>{{item[column] | stringDate}}</span>
                }
                @if (column === 'changed_by') {
                  <ng-container class="row center">
                    <span>{{item[column]}}</span>
                  </ng-container>
                }

                @if (['value', 'old_value'].includes(column)) {
                  <ng-container class="row center">
                    <span>{{item[column] | formatNumber:series.attributes?.decimal_places: true}}</span>
                  </ng-container>
                }
              </td>
            }
            @if (column === 'comments') {
              <td *matCellDef="let item;" mat-cell>
                <div style="max-height:80px;overflow-y:auto;">
                  @for (comment of item.comments; track comment) {
                    <div>{{comment}}</div>
                  }
                </div>
              </td>
            }
          </ng-container>
        }
        <tr *matHeaderRowDef="columns; sticky: true" mat-header-row></tr>
        <tr *matRowDef="let row; columns: columns;" mat-row></tr>
      </table>

      @if (!loading && dataSource?.data?.length === 0) {
        <div class="no-data-message">
          No data available for this period
        </div>
      }

    </div>
  }
</div>
